import { Component, Optional } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule, NbRadioModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-add-report-method-dialog',
  templateUrl: './add-report-method-dialog.component.html',
  styleUrls: ['./add-report-method-dialog.component.scss'],
  standalone: true,
  imports: [
    NbCardModule,
    NbButtonModule,
    NbRadioModule,
    FormsModule,
    TranslateModule
  ]
})
export class AddReportMethodDialogComponent {
  public selectedMethod: 'automatic' | 'manual' = 'automatic';

  constructor(
    @Optional() public ref: NbDialogRef<AddReportMethodDialogComponent>
  ) {}

  public confirm(): void {
    this.ref.close(this.selectedMethod);
  }

  public cancel(): void {
    this.ref.close(null);
  }
}

